module.exports = __webpack_public_path__ + "static/Nanopesos3-397fe9a1c37382cd695016d93c00bb53.webp";